// Generated by ReScript, PLEASE EDIT WITH CARE

import * as Curry from "@rescript/std/lib/es6/curry.js";
import * as React from "react";
import Classnames from "classnames";
import * as JsxRuntime from "react/jsx-runtime";
import * as BsCssJs$PrezzeeRibbon from "../../../bindings/BsCss/BsCssJs.bs.js";
import * as ReactFontawesome from "@fortawesome/react-fontawesome";
import * as Theme__Animation$PrezzeeRibbon from "../../../theme/Theme__Animation.bs.js";
import * as Theme__Responsive$PrezzeeRibbon from "../../../theme/Theme__Responsive.bs.js";
import * as Accordion__Provider$PrezzeeRibbon from "./Accordion__Provider.bs.js";
import * as FaPlus from "@fortawesome/pro-light-svg-icons/faPlus";
import * as FaChevronDown from "@fortawesome/pro-regular-svg-icons/faChevronDown";

function button(disabled) {
  return BsCssJs$PrezzeeRibbon.style([
              BsCssJs$PrezzeeRibbon.display("flex"),
              BsCssJs$PrezzeeRibbon.justifyContent("spaceBetween"),
              BsCssJs$PrezzeeRibbon.alignItems("center"),
              BsCssJs$PrezzeeRibbon.paddingTop(BsCssJs$PrezzeeRibbon.px(22)),
              BsCssJs$PrezzeeRibbon.paddingBottom(BsCssJs$PrezzeeRibbon.px(22)),
              BsCssJs$PrezzeeRibbon.paddingLeft(BsCssJs$PrezzeeRibbon.px(16)),
              BsCssJs$PrezzeeRibbon.paddingRight(BsCssJs$PrezzeeRibbon.px(16)),
              BsCssJs$PrezzeeRibbon.width(BsCssJs$PrezzeeRibbon.pct(100)),
              BsCssJs$PrezzeeRibbon.borderStyle("none"),
              BsCssJs$PrezzeeRibbon.backgroundColor("transparent"),
              BsCssJs$PrezzeeRibbon.color("currentColor"),
              BsCssJs$PrezzeeRibbon.fontSize(BsCssJs$PrezzeeRibbon.px(16)),
              BsCssJs$PrezzeeRibbon.fontWeight({
                    NAME: "num",
                    VAL: 500
                  }),
              BsCssJs$PrezzeeRibbon.textAlign("left"),
              BsCssJs$PrezzeeRibbon.hover([BsCssJs$PrezzeeRibbon.cursor(disabled ? "notAllowed" : "pointer")]),
              BsCssJs$PrezzeeRibbon.focus([BsCssJs$PrezzeeRibbon.outlineStyle("none")]),
              BsCssJs$PrezzeeRibbon.media(Theme__Responsive$PrezzeeRibbon.tabletOrDesktop, [
                    BsCssJs$PrezzeeRibbon.paddingLeft(BsCssJs$PrezzeeRibbon.px(22)),
                    BsCssJs$PrezzeeRibbon.paddingRight(BsCssJs$PrezzeeRibbon.px(22))
                  ]),
              BsCssJs$PrezzeeRibbon.media(Theme__Responsive$PrezzeeRibbon.desktop, [BsCssJs$PrezzeeRibbon.fontSize(BsCssJs$PrezzeeRibbon.px(18))])
            ]);
}

var baseIconStyle = BsCssJs$PrezzeeRibbon.style([
      BsCssJs$PrezzeeRibbon.fontSize(BsCssJs$PrezzeeRibbon.px(16)),
      BsCssJs$PrezzeeRibbon.transition(Theme__Animation$PrezzeeRibbon.regular, undefined, "easeOut", "transform"),
      BsCssJs$PrezzeeRibbon.media(Theme__Responsive$PrezzeeRibbon.desktop, [BsCssJs$PrezzeeRibbon.fontSize(BsCssJs$PrezzeeRibbon.px(24))])
    ]);

function chevron(expanded) {
  return BsCssJs$PrezzeeRibbon.merge([
              baseIconStyle,
              BsCssJs$PrezzeeRibbon.style([BsCssJs$PrezzeeRibbon.transform(expanded ? BsCssJs$PrezzeeRibbon.rotate(BsCssJs$PrezzeeRibbon.deg(180)) : BsCssJs$PrezzeeRibbon.rotate(BsCssJs$PrezzeeRibbon.deg(0)))])
            ]);
}

function plus(expanded) {
  return BsCssJs$PrezzeeRibbon.merge([
              baseIconStyle,
              BsCssJs$PrezzeeRibbon.style([BsCssJs$PrezzeeRibbon.transform(expanded ? BsCssJs$PrezzeeRibbon.rotate(BsCssJs$PrezzeeRibbon.deg(45)) : BsCssJs$PrezzeeRibbon.rotate(BsCssJs$PrezzeeRibbon.deg(0)))])
            ]);
}

var Styles = {
  button: button,
  baseIconStyle: baseIconStyle,
  chevron: chevron,
  plus: plus
};

function Accordion__Trigger(props) {
  var icon = props.icon;
  var className = props.className;
  var className$1 = className !== undefined ? className : "";
  var icon$1 = icon !== undefined ? icon : /* Chevron */0;
  var match = React.useContext(Accordion__Provider$PrezzeeRibbon.context);
  var state = match[0];
  var disabled = state.disabled;
  var expanded = state.expanded;
  var dispatch = match[1];
  var onClick = function (param) {
    if (!disabled) {
      return Curry._1(dispatch, /* Toggle */0);
    }
    
  };
  var match$1 = icon$1 ? [
      FaPlus.faPlus,
      plus(expanded)
    ] : [
      FaChevronDown.faChevronDown,
      chevron(expanded)
    ];
  return JsxRuntime.jsxs("button", {
              children: [
                props.children,
                JsxRuntime.jsx(ReactFontawesome.FontAwesomeIcon, {
                      icon: match$1[0],
                      className: match$1[1]
                    })
              ],
              className: Classnames([
                    button(disabled),
                    className$1
                  ]),
              type: "button",
              onClick: onClick
            });
}

var make = Accordion__Trigger;

export {
  Styles ,
  make ,
}
/* baseIconStyle Not a pure module */
